/// \file setFilter.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import { CustomFilter } from "./customFilter";

//currentArray is the current Array used to determine if a change occurred
//totalArray is the entire Array un-filtered.  Will be filtered on
//filter are the options of the filter.  Contains the field to check (field) the operator (contain,before,after,etc.) and the value to match with
    export const SetFilter = (props:{filter:any,currentArray:any,totalArray:any}) => {
        const currentArray = props.currentArray;
        let filterWith = props.filter;
        const totalArray = props.totalArray;
        let filtering = [];
        const remember = [];
        let normal = true;
        for(let i=0;i<totalArray.length;i++){
            const individualItem = totalArray[i];
            let setDict:any = {};
            if(typeof(individualItem)!="object"){
                normal = false;
                setDict = totalArray;
                filtering = setDict;
                remember.push({"setDict":setDict,"individualItem":individualItem});
                i = totalArray.length;
            }
            else{
                for(const key in individualItem){
                    const leafTest = individualItem[key];
                    if(typeof(leafTest)!="object"){
                        setDict[key] = leafTest.toString();
                    }
                    else{
                        for(const leaf in leafTest){
                            setDict[leaf] = leafTest[leaf];
                        }
                    }
                }
            
            filtering.push(setDict);
            remember.push({"setDict":setDict,"individualItem":individualItem});
            }
        }
        if(!filterWith.logic){
            const newFilter = {logic:"and",filters:[props.filter]};
            filterWith = newFilter;
        }
        const filteredArray = [];
        const returnArray = CustomFilter(filtering,filterWith);
        for(let i=0;i<returnArray.length;i++){
            const findItem = returnArray[i];
            for(let z=0;z<remember.length;z++){
                const setDict = remember[z]["setDict"];
                if(normal){
                    const v1 = Object.values(setDict).sort();
                    const v2 = Object.values(findItem).sort();
                    if(JSON.stringify(v1)==JSON.stringify(v2)){
                        filteredArray.push(remember[z]["individualItem"]);
                    }
                }
                else{
                    for(let y=0;y<setDict.length;y++){
                        const compareWith = setDict[y];
                        if(findItem==compareWith){
                            filteredArray.push(compareWith);
                        }
                    }
                }
            } 
        }
        const updateFilter = (JSON.stringify(currentArray)!==JSON.stringify(filteredArray));
        return({filteredArray,updateFilter});
    };